import React, { Component } from 'react';
import EdittableHeader from './edittableHeader';
import EdittableContent from './edittableContent';

class TextBlock extends Component {
  state = { showDeleteBtn: false }

  handleChangeHeader = e => {
    const {
      onChange,
      block: { content }
    } = this.props;
    const { value } = e.target;
    onChange({ header: value, content });
  };

  handleChangeContent = content => {
    const {
      onChange,
      block: { header }
    } = this.props;
    onChange({ header, content });
  };

  handleMouseEnter = () => {
    this.setState({ showDeleteBtn: true });
  }

  handleMouseLeave = () => {
    this.setState({ showDeleteBtn: false });
  }

  render() {
    const {
      block, onClickDeleteButton, maxImageSizeMB, fileType, userToken, slug
    } = this.props;
    const { showDeleteBtn } = this.state;

    return (
      <div
        className='eventDetail_main_detail_block'
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        { showDeleteBtn && (
          <a onClick={onClickDeleteButton} className='eventDetail_main_detail_block_delete_btn'>
            <i className='fal fa-trash-alt' />
          </a>
        ) }
        <EdittableHeader value={block.header} onChange={this.handleChangeHeader} />
        <EdittableContent
          value={block.content} onChange={this.handleChangeContent} maxImageSizeMB={maxImageSizeMB}
          fileType={fileType}
          userToken={userToken}
          slug={slug}
        />
      </div>
    );
  }
}

export default TextBlock;



// WEBPACK FOOTER //
// ./src/components/contentEditor/components/textBlock.js